<template>
  <div class="tableWithPerPageSelection" v-if="critereRechercheRemiseBancaire">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('remiseBancaire.titre')}}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <a class="button is-addOrEdit"
            :class="{'button-access-no-permission' :
            !checkPermissions(constantes.REMISES_BANCAIRES.maj) }"
            @click="checkPermissions(constantes.REMISES_BANCAIRES.maj) ?
            modalAddRemiseBancaire = true : showPopUp()">
              {{ $t('remiseBancaire.bouttonAdd')}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="modalAddRemiseBancaire" has-modal-card class="modal">
      <app-add-remise-bancaire :modal="modalAddRemiseBancaire"
                               oncancel="modalAddRemiseBancaire = false"
                               @close="modalAddRemiseBancaire = false">
      </app-add-remise-bancaire>
    </b-modal>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-actions
              @handleAction="handleAction"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="hasRemiseBancaireSelected"
            ></selecteur-actions>
          </div>
          <form @submit.prevent="rechercheIntoChildren()"
                class="column is-5 pdr-0 pdl-0">
              <b-input :placeholder="$t('remiseBancaire.recherche')" type="search" icon="magnify"
                       v-model="critereRechercheRemiseBancaire.auto">
              </b-input>
          </form>
          <div class='column is-narrow'>
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('remiseBancaire.filtre.title')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="level-right columns">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="constantes.REMISES_BANCAIRES.exporter"
            :action="() => openExportReglement = true"
            :secondaryExports="secondaryExports"/>
        </div>
        <parametrage-table
          :referenceTable="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <remise-bancaire-table v-if="startArrayRendering"
      :sens="constantes.SENS_VENTE"
      :referenceTable="referenceTable"
      :permissions="constantes.REMISES_BANCAIRES"
      :ref="referenceTable">
    </remise-bancaire-table>
    <b-modal v-model="openExportReglement" has-modal-card class="modal"
             :width="500">
      <export-excel-reglement></export-excel-reglement>
    </b-modal>
    <b-modal v-model="openExportAnnulation" has-modal-card class="modal"
             :width="500">
      <export-excel-annulation></export-excel-annulation>
    </b-modal>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <app-pop-up-suppression
        oncancel="closePopUp()"
        :messHeader="remiseBancaireASupp.length > 1
        ? $t('supprimerRemiseBancaire.deleteMultiple') : $t('supprimerRemiseBancaire.delete')"
        :messFooter="remiseBancaireASupp.length > 1 ?
        $t('supprimerRemiseBancaire.irreversibleMultiple')
        : $t('supprimerRemiseBancaire.irreversible')"
        :isErrorPopup.sync="isErrorPopup"
        :messagesPopup="messagesPopup"
        :cancel="$t('supprimerRemiseBancaire.no')"
        :validate="$t('supprimerRemiseBancaire.yes')"
        @no="closePopUp()"
        @yes="remove()">
      </app-pop-up-suppression>
    </b-modal>
    <div class="componentBrief" v-show="showFiltre === true">
      <filtre-remise-bancaire ref="filtreRemiseBancaire"
                              @toggleFiltre="setShowFiltre"
                              @recherche="makeRechercheFilter"/>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import inProgress from '@/services/general/inProgress';
import breadcrumb from '@/components/general/breadcrumb';
import popUpSuppression from '@/components/general/popUpPrevention';
import messageSucces from '@/services/general/messageSucces';
import addRemiseBancaire from '@/components/remiseBancaire/p_addRemiseBancaire';
import { remove } from '@/api/remiseBancaire/index';
import { REMISES_BANCAIRES } from '@/configuration/permissionsBodacConf';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import filtreRemiseBancaire from '@/components/remiseBancaire/filtreRemiseBancaire';
import { ACTION_DELETE } from '@/configuration/general/actionsConf';
import selecteurActions from '@/components/general/selecteurAction';
import remiseBancaireTable from '@/components/remiseBancaire/listeRemiseBancaire/remiseBancaireTable';
import { SENS_VENTE } from '@/configuration/devisConf';
import subscribeMutation from '@/services/store/subscribeMutation';
import exportExcelReglement from '@/components/remiseBancaire/listeReglements/p_exportExcelReglement';
import exportExcelAnnulation from '@/components/remiseBancaire/p_exportAnnulation';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import { REFERENCE_TABLE_REMISE_BANCAIRE } from '@/configuration/general/referenceTableConf';
import parametrageTable from '@/components/general/parametrageTable';
import exportExcelButton from '@/components/general/button/exportExcelButton';

const RemiseBancaire = createNamespacedHelpers('remiseBancaire');
const permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      remiseBancaireASupp: [],
      popUpSuppression: false,
      modalAddRemiseBancaire: false,
      isErrorPopup: false,
      messagesPopup: [''],
      unsubscribeValue: null,
      showFiltre: false,
      openExportReglement: false,
      openExportAnnulation: false,
      actions: [
        { action: ACTION_DELETE, translation: 'remiseBancaire.dataTable.delete' },
      ],
      constantes: {
        SENS_VENTE,
        REMISES_BANCAIRES,
      },
      referenceTable: REFERENCE_TABLE_REMISE_BANCAIRE,
      startArrayRendering: false,
    };
  },
  beforeDestroy() {
    this.unsubscribeValue();
    if (this.lockMenu) this.setLockMenu(false);
  },
  async mounted() {
    this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.rechercheIntoChildren, this.goFirstPageIntoChildren);
    this.setInformationPage(this.$t('pageGescom.remiseBancaire.liste'));
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreRemiseBancaire.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    closePopUp() {
      this.popUpSuppression = false;
      this.remiseBancaireASupp = [];
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    rechercheIntoChildren() {
      this.$refs[this.referenceTable].recherche();
    },
    goFirstPageIntoChildren() {
      this.$refs[this.referenceTable].goFirstPage();
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.rechercheIntoChildren();
    },
    async remove() {
      const promises = [];
      this.popUpSuppression = false;
      this.remiseBancaireASupp.forEach((el) => {
        promises.push(remove(el.id));
      });
      let successCount = 0;
      await Promise.all(promises).then(values => {
        values.forEach(response => {
          if (response.data.success) successCount += 1;
        });
      });
      await Promise.all(promises);
      if (successCount > 1) {
        messageSucces(successCount + ' ' + this.$t('remiseBancaire.remisebancaireSupprimeMult'));
      } else {
        messageSucces(successCount + ' ' + this.$t('remiseBancaire.remisebancaireSupprime'));
      }
      this.remiseBancaireASupp = [];
      this.rechercheIntoChildren();
    },
    suppressionSelection() {
      this.remiseBancaireASupp = this.remiseBancaires.filter((el) => {
        return el.selected;
      });
      this.popUpSuppression = true;
    },
    handleAction(action) {
      if (action === ACTION_DELETE) {
        if (this.checkPermissions(REMISES_BANCAIRES.supprimer)) {
          this.suppressionSelection();
        } else this.showPopUp();
      }
    },
    async reinitialiser() {
      await this.$refs.filtreRemiseBancaire.initializeFiltre();
      this.$refs.filtreRemiseBancaire.viderCritere();
      this.$refs.filtreRemiseBancaire.appliquerCritere();
      this.showFiltre = false;
    },
  },
  components: {
    appBreadcrumb: breadcrumb,
    appPopUpSuppression: popUpSuppression,
    appAddRemiseBancaire: addRemiseBancaire,
    filtreRemiseBancaire,
    selecteurActions,
    remiseBancaireTable,
    exportExcelReglement,
    exportExcelAnnulation,
    parametrageTable,
    exportExcelButton,
  },
  computed: {
    ...RemiseBancaire.mapGetters({
      remiseBancaires: 'items',
      critereRechercheRemiseBancaire: 'critereRechercheRemiseBancaire',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      lockMenu: 'lockMenu',
    }),
    secondaryExports() {
      return [
        {
          libelle: this.$t('remiseBancaire.exportAnnulation'),
          action: () => { this.openExportAnnulation = true; },
        },
      ];
    },
    hasRemiseBancaireSelected() {
      return this.remiseBancaires.filter((remiseBancaire) => {
        return remiseBancaire.selected === true;
      }).length > 0;
    },
    breadcrumb() {
      return [
        { title: this.$t('remiseBancaire.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('remiseBancaire.titre'), route: { name: 'l.bodac.remises_bancaires' }, isActive: true },
      ];
    },
    nombreCritere() {
      let nbCritere = calculNombreCritere(this.critereRechercheRemiseBancaire, ['auto', 'exporteeEnCompta', 'sens', 'datesRemise']);
      if (this.critereRechercheRemiseBancaire.exporteeEnCompta !== null) nbCritere += 1;
      if (this.critereRechercheRemiseBancaire.datesRemise.dateDebut !== null) nbCritere += 1;
      if (this.critereRechercheRemiseBancaire.datesRemise.dateFin !== null) nbCritere += 1;
      return nbCritere > 9 ? '+9' : nbCritere;
    },
  },
};
</script>
